module.exports = __webpack_public_path__ + "static/media/mckenzie.7a416519.jpg";